module.exports = __webpack_public_path__ + "08_long_gray.6ed4ccf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/08_long_gray.png
// module id = BYW7
// module chunks = 0